import React, { useState, useEffect } from 'react'
import Card from '@mui/material/Card'
import { useLocation, useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { useAppServices } from 'hook/services'
import Loader from 'examples/Loader'
import Swal from 'sweetalert2'

const GoHighLevel = () => {
  const AppServices = useAppServices()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { locationId, companyId, app_id } = useParams()
  const [loader, setloader] = useState(true)
  const { search } = useLocation()
  const type = new URLSearchParams(search).get('type')

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  })
  const { vertical, horizontal, open } = state
  const [services, setServices] = useState([])
  const [selectedCompany, setSelectedCompany] = useState('') // State to store the selected company
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setState({ ...state, open: false })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const payload = {
      app_cred: {
        email,
        password,
        companyId: selectedCompany,
      },
      location_id: locationId,
      company_id: companyId,
      app_id: app_id,
      connection_status: 'active',
      type: type,
    }
    console.log(payload, 'payload')
    try {
      const response = await axios.post(
        'https://webhook.alltheapps.io/v1/simpro/create-credentials',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      setState({ ...state })
      setServices(response.data.data)
    } catch (error) {
      console.error('Error connecting:', error.message)
    }
  }
  const handleSave = async (e) => {
    e.preventDefault()
    const payload = {
      app_cred: {
        email,
        password,
        companyId: selectedCompany,
      },
      location_id: locationId,
      company_id: companyId,
      app_id: app_id,
      connection_status: 'active',
      type: type,
    }
    console.log(payload, 'payload')
    try {
      const response = await axios.post(
        'https://webhook.alltheapps.io/v1/simpro/save-credentials',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      setLoading(true)
      if (response.data.success) {
        Swal.fire({
          title: 'Connected Successfully',
          icon: 'success',
        })
        setState({ ...state })
        setServices(response.data.data)
        setLoading(true)
      } else {
        alert('Something wents wrong please try again')
      }
    } catch (error) {
      console.error('Error connecting:', error.message)
    }
  }
  const getCreds = async () => {
    const { response } = await AppServices.app_token.get_credentials({
      query: `type=${type}&location_id=${locationId}&app_id=${app_id}`,
    })
    if (response) {
      setEmail(response.data?.app_cred?.email)
      setPassword(response.data?.app_cred?.password)
      setSelectedCompany(response.data?.app_cred?.selectedCompany)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const onLoad = async () => {
    getCreds()
  }

  useEffect(onLoad, [])
  return loader ? (
    <Loader />
  ) : (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundImage:
          'url("https://cdn.pixabay.com/photo/2016/09/05/15/07/concrete-1646788_1280.jpg")',
        backgroundSize: 'cover',
      }}
    >
      <Card
        sx={{
          width: '42%',
          textAlign: 'center',
          padding: '2rem',
          borderRadius: '29px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <Box
          sx={{
            bgcolor: 'info.main',
            borderRadius: 'lg',
            boxShadow: 'info',
            padding: 2,
            marginBottom: 1,
          }}
        >
          <Typography variant="h4" gutterBottom style={{ color: 'white' }}>
            Connect with Simpro
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mb: 2 }}>
          To get started, enter your apiKey and Base URL below and click "Connect."
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            type="text"
            label="apiKey"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ mb: 2 }}
            required
          />

          <TextField
            type="text"
            label="BASE_URL"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ mb: 2 }}
            required
          />
          <Typography
            variant="h6"
            style={{
              textAlign: 'left',
              fontSize: '.7rem',
              marginTop: '-10px',
              marginLeft: '4px',
              color: '#000',
            }}
          >
            hint: https://sample.com
          </Typography>

          <Button
            type="submit"
            // variant="contained"
            // color="info"
            fullWidth
            sx={{ mt: 2 }}
            style={{
              fontSize: '0.9rem',
              textTransform: 'capitalize',
              background: '#1A73E8',
              color: 'white',
            }}
          >
            {loading ? 'Connected' : 'Get Companies'}
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            message="Connected Successfully"
            key={vertical + horizontal}
          />
        </Box>

        {services.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Select
              label="Select Companies"
              value={selectedCompany}
              onChange={(e) => setSelectedCompany(e.target.value)}
              fullWidth
            >
              {services.map((service) => (
                <MenuItem key={service.ID} value={service.ID}>
                  {service.Name}
                </MenuItem>
              ))}
            </Select>
            <Button
              type="submit"
              sx={{ mt: 2 }}
              style={{
                fontSize: '0.9rem',
                textTransform: 'capitalize',
                background: '#1A73E8',
                color: 'white',
                textAlign: 'start',
              }}
              onClick={handleSave}
            >
              Connect
            </Button>
          </Box>
        )}
      </Card>
    </div>
  )
}

export default GoHighLevel
